import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "item", "itemBlockSize", "children", "onClick", "use"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useSetPlaylistThumbnail } from '../savedItemsQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useLesson } from '../../lessons/lessonQueries';
import { ThumbnailItem } from '../../thumbnail';
import { useTrack } from '../../tracks';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChangePlaylistThumbnailButton = _ref => {
  let {
      playlistId,
      item,
      itemBlockSize = '24px',
      children,
      onClick,
      use
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [setPlaylistThumbnail] = useSetPlaylistThumbnail(playlistId);
  const trackId = item && item.type === 'TRACK' && item.itemId;
  const lessonId = item && item.type === 'LESSON' && item.itemId;
  const language = item && item.language;
  const {
    lesson,
    lessonLoading
  } = useLesson(Number(lessonId), language, !lessonId);
  const {
    track,
    trackLoading
  } = useTrack(Number(trackId), language, !trackId);
  const isLoading = lessonLoading || trackLoading;
  const handleOnClick = e => {
    if (lesson || track) {
      if (track) {
        setPlaylistThumbnail(track.previewThumbnailRectangleUrl, track.previewThumbnailSquareUrl);
      } else {
        setPlaylistThumbnail(lesson.previewThumbnailRectangleUrl, lesson.previewThumbnailSquareUrl);
      }
    }
    if (onClick) onClick(e);
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    disabled: isLoading,
    onClick: handleOnClick,
    use: use || 'unstyled'
  }, props, {
    children: children ? /*#__PURE__*/_jsx(_Fragment, {
      children: children
    }) : item ? /*#__PURE__*/_jsxs(TFlex, {
      blockSize: itemBlockSize,
      gap: 8,
      children: [/*#__PURE__*/_jsx(ThumbnailItem, {
        language: language,
        lessonId: lessonId || undefined,
        trackId: trackId || undefined
      }), /*#__PURE__*/_jsx(TruncateString, {
        matchContentWidth: true,
        children: item.name
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyNav.cardMenu.changeThumbnail"
    })
  }));
};
export default ChangePlaylistThumbnailButton;